export default __webpack_public_path__ + "static/media/statistics-fees.05c18919.svg";